// extracted by mini-css-extract-plugin
export default {"wrapper":"_9d21c90c","content":"_af42e1d6"};